import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function Audience() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forWho = ['Mujeres profesionales y ejecutivas que dependen de su agudeza mental.', 'Madres que gestionan la complejidad del hogar y sienten que los detalles se les escapan.', 'Mujeres de más de 45 años que sienten que su vocabulario se ha "encogido" en el último año.', 'Cualquier mujer en perimenopausia o menopausia que se siente "desconectada" de sí misma.'];
  const notFor = ['Personas que buscan una pastilla milagrosa para seguir comiendo procesados.', 'Quienes no están dispuestas a ajustar sus hábitos de sueño o nutrición por 21 días.', 'Hombres o mujeres jóvenes que no atraviesan cambios hormonales de madurez.'];
  return <section ref={ref} className="w-full bg-cream py-16 md:py-20" data-id="element-13">
      <div className="max-w-6xl mx-auto px-6" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} data-id="element-15">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-16">
            <div data-id="element-17">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-teal-900" data-id="element-18">
                Para Quién Es Este Protocolo
              </h2>

              <div className="space-y-4" data-id="element-19">
                {forWho.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: -20
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex gap-3 items-start" data-id="element-20">
                    <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-21" />
                    <p className="text-gray-800" data-id="element-22">{item}</p>
                  </motion.div>)}
              </div>
            </div>

            <div data-id="element-23">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-teal-900" data-id="element-24">
                Para Quién NO Es
              </h2>

              <div className="space-y-4" data-id="element-25">
                {notFor.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: 20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: 20
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex gap-3 items-start" data-id="element-26">
                    <XCircleIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-27" />
                    <p className="text-gray-800" data-id="element-28">{item}</p>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}